// extracted by mini-css-extract-plugin
export default {"form":"EditarServico_form__UnLR4","areaBtn":"EditarServico_areaBtn__5jzr7","btn":"EditarServico_btn__AAzPh","btn2":"EditarServico_btn2__9yAZk"};